import React from 'react';
import { LegalShell } from '../components/legal/LegalShell';
export function Privacidad() {
  return <LegalShell title="Política de privacidad" data-id="element-1188">
      <p data-id="element-1189">
        Recopilamos únicamente los datos necesarios para entregarte tu acceso:
        correo electrónico y registro de compra.
      </p>
      <p data-id="element-1190">
        Tu información no se vende ni se comparte con terceros con fines
        publicitarios.
      </p>
      <p data-id="element-1191">
        Utilizamos proveedores externos (autenticación, almacenamiento y
        procesamiento de pagos) que aplican sus propias políticas de seguridad.
      </p>
      <p data-id="element-1192">
        Puedes solicitar la eliminación de tu cuenta y tus datos en cualquier
        momento.
      </p>
    </LegalShell>;
}